import { render, staticRenderFns } from "./HeaderLastAsigned.vue?vue&type=template&id=94716b4c"
import script from "./HeaderLastAsigned.vue?vue&type=script&lang=js"
export * from "./HeaderLastAsigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports